import {
  Directive,
  TemplateRef,
  ViewContainerRef,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';

@Directive({
  selector: '[appRechargeUsers]',
})
export class RechargeUsersDirective implements OnChanges {
  @Input() appRechargeUsers!: boolean;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['appRechargeUsers']) {
      this.viewContainerRef.clear();
      this.viewContainerRef.createEmbeddedView(this.templateRef);
    }
  }

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainerRef: ViewContainerRef
  ) {
    this.viewContainerRef.createEmbeddedView(templateRef);
  }
}
